// state
export const state = {
    progress: []
}

// getters
export const getters = {
    progress: state => state.progress,
}

// mutations
export const mutations = {
    setDiary(state, progress) {
        state.progress = progress
    },
}

// actions
export const actions = {
    async getDiary({ commit, dispatch }, params) {
        dispatch('loading/addLoading', '', { root: true })
        const { data } = await axios.post('/api/v1/student/progress', params);
        commit('setDiary', data)
        dispatch('loading/subLoading', '', { root: true })
    },
}
